export const SITE_NAME = "Basetao Spreadsheet";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";

const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

export interface FaqQa {
  q: string;
  a: string;
}

function buildOrganization() {
  return {
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_ORIGIN,
    logo: FAVICON_URL,
  };
}

export function buildWebSiteSchema(lang: string, description: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${SITE_ORIGIN}/${lang}`,
    description,
    inLanguage: lang,
    publisher: buildOrganization(),
  };
}

export function buildArticleSchema(params: {
  lang: string;
  slug: string;
  title: string;
  description: string;
  image: string;
}) {
  const { lang, slug, title, description, image } = params;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    inLanguage: lang,
    mainEntityOfPage: `${SITE_ORIGIN}/${lang}/article/${slug}`,
    image,
    author: buildOrganization(),
    publisher: buildOrganization(),
  };
}

export function buildFaqPageSchema(faqs: FaqQa[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}